import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import DoneIcon from '@material-ui/icons/Done'
import ClearIcon from '@material-ui/icons/Clear'
import GreenLockIcon from '../../Icons/GreenLockIcon'
import { useStyles } from './HiddenTestCaseStyles'

function HiddenTestCase({ testcase, index }) {
  const classes = useStyles()
  return (
    <Grid
      data-testid="render-hidden-test-case"
      container
      direction="column"
      className={classes.hiddenTestCaseWrapper}
    >
      {testcase?.testCaseInfo?.status === 'PASSED' && (
        <Grid
          data-testid="render-passed-test-case"
          container
          alignItems="center"
          className={classes.testCaseMsg}
        >
          <Typography className={classes.testcasePassed}>
            Test case {index + 1} passed
          </Typography>
          <DoneIcon className={classes.testcasePassedIcon} />
        </Grid>
      )}
      {testcase?.testCaseInfo?.status === 'FAILED' && (
        <Grid
          data-testid="render-failed-test-case"
          container
          alignItems="center"
          className={classes.testCaseMsg}
        >
          <Typography className={classes.testcaseFailed}>
            Test case {index + 1} failed
          </Typography>
          <ClearIcon className={classes.testcaseFailedIcon} />
        </Grid>
      )}
      <Typography variant="body2" className={classes.finishMsg}>
        Finished in {(testcase?.duration / 1000).toFixed(2)} seconds
      </Typography>
      <Grid container className={classes.resultContainer}>
        <Grid item className={classes.iconContainer}>
          <Grid item className={classes.iconWrapper}>
            <GreenLockIcon />
          </Grid>
        </Grid>

        <Typography className={classes.hiddenTestcaseText}>
          Hidden test case
        </Typography>
      </Grid>
    </Grid>
  )
}

export default HiddenTestCase
